<template>
  <vuestic-navbar>
    <img slot="logo" src="/logo.png" alt="logo" style="width: 200px; margin-left: -17px; z-index: 3;">
      <span slot="center" class="header-elem-wrapper justify-content-lg-start col nome" v-if="autoescola != ''" >
          {{autoescola}}
      </span>
    <header-selector :isOpen.sync="valueProxy" id="header"/>

    <!-- <message-dropdown class="col nav-item"/> -->
    <notification-dropdown v-if="id_role != 3 && id_role != 4 && id_role != 9" class="col noti nav-item"/>
    <profile-dropdown v-if="id_role == 4" id="profile" class="col nav-item" style="margin-left: 250px; margin-bottom: 40px;"/>
    <profile-dropdown v-else-if="id_role == 3" id="profile" class="col nav-item" style="margin-left: 250px;"/>
    <profile-dropdown v-else-if="id_role == 9" id="profile" class="col nav-item" style="margin-left: 250px;"/>

    <profile-dropdown v-if="id_role != 4 && id_role != 3 && id_role != 9" id="profile" class="col nav-item"/>
    <span class="header-elem-wrapper menu-icon-container justify-content-lg-start col profile">
      <!-- {{ nomeInicial(nome) }} -->
    </span>

  </vuestic-navbar>

</template>

<script>
import VuesticIconVuestic from '../../../vuestic-theme/vuestic-components/vuestic-icon/VuesticIconVuestic'
import VuesticNavbar from '../../../vuestic-theme/vuestic-components/vuestic-navbar/VuesticNavbar'
import HeaderSelector from './components/HeaderSelector'

import LanguageDropdown from './components/dropdowns/LanguageDropdown'
import ProfileDropdown from './components/dropdowns/ProfileDropdown'
import NotificationDropdown from './components/dropdowns/NotificationDropdown'
import MessageDropdown from './components/dropdowns/MessageDropdown'

import urlApi from '../../../router/urlApi'

export default {
  name: 'app-navbar',
  data () {
    return {
      projeto: process.env.VUE_APP_NOME_PROJETO,
      id_role: localStorage.id_role,
      isMobile: false,
      nome: window.localStorage['nome'] ?  window.localStorage['nome'].toUpperCase() : '',
      autoescola: window.localStorage['nome_fantasia'] != 'null' ? window.localStorage['nome_fantasia'].toUpperCase() : '',
    }
  },
  mounted(){
    if(window.innerWidth <= 991){
      this.isMobile = true;
    }

  },
  components: {
    VuesticIconVuestic,
    VuesticNavbar,
    HeaderSelector,
    MessageDropdown,
    NotificationDropdown,
    LanguageDropdown,
    ProfileDropdown,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    valueProxy: {
      get () {
        return this.isOpen
      },
      set (opened) {
        this.$emit('toggle-menu', opened)
      },
    },
  },
  methods: {
    atualizar(){
      this.$http.get(urlApi + '/getran').then(function(response){
        console.log(response)
      })
    },
    nomeInicial(nome){
      return nome.split(' ')[0] + ' ' + nome.split(' ')[1];
    }
  },
}
</script>

<style scoped>
  /* .col{
    display: flex;
    vertical-align: middle;
    justify-content: right;
  } */
  #header {
    display: none;
  }

  #atualizar{
    cursor: pointer;
    padding-top: 15px;
    font-size: 200%;
    color: white;
  }
  .nome{
    color: white;
    font-weight: bold;
  }
  .autoescola{
    position: absolute;
    padding-left: 20%;
    padding-top: 1%;
  }
  @media (max-width: 991px) {
    img {
      margin-top: 10px;
    }
    .col {
    display: flex;
    vertical-align: middle;
    justify-content: right;
    }
    .noti {
      margin-left: 75%;
      padding-right: 7%;
      position: relative;
      margin-top: -37px;
    }
    #header {
      /* padding-bottom: 20px; */
      display: block;
      margin-top: -5px;
    }
    #profile {
      margin-top: -37px;
    }
  }
  @media (max-width: 425px) {
    #profile {
      margin-right: -10px;
      padding-left: 10px;
    }
  }
  @media (max-width: 375px) {
     .col {
    display: flex;
    vertical-align: middle;
    justify-content: right;
    }
    .noti {
      margin-left: 70%;
    }
   #header {
      display: block;
      margin-top: -5px;
     -webkit-margin-right: -5px;

      margin-right: 2px;
      -webkit-margin-right: 2px;

    }
    #profile {
      margin-top: -37px;
      margin-right: -19px;
      -webkit-margin-right: 19px;
    }
  }
  @media (max-width: 320px) {
    #profile {
      margin-right: -13px;
      -webkit-margin-rigth: 1px;
    }
  }
</style>
